export const ModelC = {
    name :  { path: ".name" },
    type : { 
        path: ".n/a",
        _default: {          
            multiChoice: "choice",
            uniqueChoice: "choice"
        },
        fieldValidate: '.type',
        valuesValidate: ["multiChoice", "uniqueChoice"]
    },
    label : { path: ".label" },
    required : { path: ".required" },
    inputType : { 
        path: '.n/a',  
        _default: {          
            multiChoice: "data.inherited !== undefined ?'multiOther': 'multi'",
            uniqueChoice: "data.inherited !== undefined ?'radioOther': 'radio'"
        }, 
        fieldValidate: '.type',
        valuesValidate: ["multiChoice", "uniqueChoice"]
    },
    help: {
        path: ".help",
        _default: ""
    },
    options: {
        path: ".options",
        _default: ["opción 1"],
        fieldValidate: '.type',
        valuesValidate: ["multiChoice", "uniqueChoice"]
    },
    properties: {
        path: ".n/a",
        fieldValidate: '.type',
        valuesValidate: ["multiChoice", "uniqueChoice"],
        _properties: { 
            min: {
                path: ".n/a",
                _default: 1,//Si el componente no tiene la propiedad min
                fieldValidate: '.type',
                valuesValidate: ["multiChoice"]
            },
            max: {
                path: ".n/a",
                _default: 1,//Si el componente no tiene la propiedad max
                fieldValidate: '.type',
                valuesValidate: ["multiChoice"]
            },
            default: {
                path: ".n/a",
                _default: "Otro, Cual?",//Si el componente no tiene la propiedad default
                fieldValidate: '.inherited[0].type',
                valuesValidate: ["input"]
            },                      
        }         
    }

}